import React, { useEffect } from 'react'
import './found-code-item.styles.scss';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import HiddenText from '@/components/SHARED/hidden-text/hidden-text.component';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const FoundCodeItem = ({ 
    codeInfo,
    setIndActivityData
 }) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const navigate = useNavigate();

    return (
        <div className={`found-code-item g-list-item ${screenSize}`}>
            <ImageContainer 
                src={codeInfo.icon} 
                alt='found code item icon' 
                className='found-code-icon' />
            <HiddenText 
                text={codeInfo.title} 
                hidden={true} />
            <div>{codeInfo.info}</div>
            <div className='meta'>{format(new Date(codeInfo.ts), 'Pp')}</div>
            <div className='buttons'>
                {
                    (codeInfo.data && Object.values(codeInfo.data).length > 0) && 
                    <button 
                        className='g-button small-btn'
                        onClick={() => {
                            // setIndActivityData(codeInfo);
                            navigate(codeInfo.id);
                        }} >
                        View
                    </button>
                }
            </div>
        </div>
    )
}

export default FoundCodeItem